import { Link } from '@tanstack/react-router'
import { Card, CardContent, CardHeader, CardTitle } from '@/ui/components/common/Card'

/**
 * Single KPI tile used in the StatsSection grid: title, value, icon and
 * description, optionally wrapped in a navigation link.
 */
export function StatCard({
  title,
  value,
  icon: Icon,
  description,
  href,
}: {
  title: string
  value: number | string
  icon: React.ComponentType<{ className?: string }>
  description: string
  href?: string
}) {
  const content = (
    <Card className="hover:shadow-lg transition-shadow cursor-pointer">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <div className="space-y-1">
          <CardTitle className="text-sm font-medium">{title}</CardTitle>
          <p className="text-2xl font-bold">{value}</p>
        </div>
        <div className="p-2 rounded-full bg-primary/10">
          <Icon className="w-5 h-5 text-primary" />
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-muted-foreground">{description}</p>
      </CardContent>
    </Card>
  )

  return href ? <Link to={href}>{content}</Link> : content
}
